import React,{useContext} from "react";
import { AcquaintanceContext } from "../../shared/Shared";
import "./Acquaintance.css"

export default function Acquaintance(props) {
    let [acquaintance, setAcquaintance] =  useContext(AcquaintanceContext);

    return (
        <div className="containAcc">
            <div className="row">
                {props.ModuleDetails.map((item, index) => (
                    <div className="col-xs-12 col-sm-6 contOption" style={{ fontSize: "15px" , padding:"10px "}} key={index}>
                        <input type="radio" id={item.Id} name="radio" onClick={()=>setAcquaintance(item.Id)}/>
                        <label for={item.Id}>{item.Title}</label>
                    </div>
                ))}
            </div>
        </div>



    )

}